import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * O DICIONÁRIO DE SITUAÇÃO — o que cada etapa PROVA, o que FALTA e o que NÃO SE
 * DIZ ao cliente.
 *
 * ⛔ FONTE ÚNICA, lida pela TELA e pela ISABELLA. É isso que impede as duas
 * falarem coisas diferentes sobre o mesmo pedido.
 *
 * Ele nasceu de um caso real (16/09/2026): um PN com PORTABILIDADE AGENDADA
 * para o dia seguinte às 12:00, SMS Anatel já respondido, e a IsabellA
 * encerrou o atendimento dizendo que o cliente "optou por não reenviar o SMS" e
 * mandou buscar 2ª via de chip. O dado estava certo no banco e ela tinha a
 * ferramenta. Faltava a TRADUÇÃO da etapa em ação.
 *
 * ⚠️ E o risco é o mesmo para gente: quem abre a conversa vê a fila
 * ("PORTABILIDADE AGENDADA") e precisa saber o que ela significa — não decorar
 * 36 status.
 *
 * Estava dentro do CRMPanel. Saiu para cá quando a conversa passou a mostrar a
 * etapa também: duas cópias do mesmo dicionário divergiriam na primeira edição.
 */

export type SituacaoEtapa = {
  /** O que esta etapa comprova que JÁ aconteceu. */
  prova: string | null;
  /** O que ainda falta para o pedido andar. */
  falta: string | null;
  /** O que é PROIBIDO dizer ou oferecer nesta etapa. */
  nao_diga: string | null;
};

/** Chave do mapa: `QUADRO|COLUNA`. */
export function chaveSituacao(quadro: string | null | undefined, coluna: string | null | undefined) {
  return `${quadro ?? ''}|${coluna ?? ''}`;
}

export function useDicionarioSituacao() {
  return useQuery({
    queryKey: ['dicionario-situacao-status'],
    // 10 min: o dicionário muda por migration, não por uso.
    staleTime: 10 * 60_000,
    queryFn: async (): Promise<Record<string, SituacaoEtapa>> => {
      const { data, error } = await supabase
        .from('status_catalogo')
        .select('quadro, coluna, prova, falta, nao_diga')
        .eq('ativo', true);
      if (error) throw error;
      const mapa: Record<string, SituacaoEtapa> = {};
      for (const r of (data || []) as Array<{
        quadro: string | null; coluna: string | null;
        prova: string | null; falta: string | null; nao_diga: string | null;
      }>) {
        if (!r.coluna) continue;
        mapa[chaveSituacao(r.quadro, r.coluna)] = { prova: r.prova, falta: r.falta, nao_diga: r.nao_diga };
      }
      return mapa;
    },
  });
}
